import Link from 'next/link';
import Facebook from './Svg/Facebook';
import Instagram from './Svg/Instagram';
import LinkedIn from './Svg/LinkedIn';
import Twitter from './Svg/Twitter';
import Youtube from './Svg/Youtube';
import Tiktok from './Svg/Tiktok';
import Mastodon from './Svg/Mastodon';
import Threads from './Svg/Threads';

const SocialLink = (props) => {
    const { name, url } = props;
    if (!name || !url) return null;

    let icon;

    switch (name) {
        case 'facebook':
            icon = <Facebook fill="#000" />;
            break;
        case 'instagram':
            icon = <Instagram fill="#000" />;
            break;
        case 'linkedin':
            icon = <LinkedIn fill="#000" />;
            break;
        case 'twitter':
            icon = <Twitter fill="#000" />;
            break;
        case 'youtube':
            icon = <Youtube fill="#000" />;
            break;
        case 'tiktok':
            icon = <Tiktok fill="#212121" />;
            break;
        case 'mastodon':
            icon = <Mastodon fill="#212121" />;
            break;
        case 'threads':
            icon = <Threads fill="#212121" />;
            break;
        default:
            icon = null;
            break;
    }

    return (
        <Link href={url}>
            <a target="_blank" rel="noopener noreferrer">
                {icon}
            </a>
        </Link>
    );
};

export default SocialLink;
